// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-127a7c0c]{font-family:Open Sans,sans-serif;font-size:.8rem;letter-spacing:-.02rem}[dir] div[data-v-127a7c0c]{padding:4px 8px;border-radius:.5rem}.toFill[data-v-127a7c0c]{color:#7c24ec}[dir] .toFill[data-v-127a7c0c]{background-color:#f5f0fb}.filled[data-v-127a7c0c]{color:#2444ec}[dir] .filled[data-v-127a7c0c]{background-color:#ecedf6}.text-bold[data-v-127a7c0c]{font-weight:600}", ""]);
// Exports
module.exports = exports;
